/* OZ:lazy-video 自动播放视频延迟加载。
 * 远程 main.js 的 internal-video 在页面布局完成前就会把 data-src 换成 src，首屏下方的视频也会立刻下载（首页约 25MB）。
 * sections/multirow.liquid 把自动播放视频的 source 改成 data-oz-lazy-src，这里在接近视口（上下 200px）时再加载并播放，
 * 效果和线上 Essence 一致。 */
(function () {
  if (window.ozLazyVideoInit) return;
  window.ozLazyVideoInit = true;

  function load(video) {
    video.querySelectorAll('source[data-oz-lazy-src]').forEach(function (source) {
      source.src = source.getAttribute('data-oz-lazy-src');
      source.removeAttribute('data-oz-lazy-src');
    });
    video.load();
    if (video.autoplay || video.hasAttribute('autoplay')) {
      var playing = video.play();
      if (playing && typeof playing.catch === 'function') playing.catch(function () {});
    }
  }

  function init(root) {
    var videos = Array.prototype.filter.call((root || document).querySelectorAll('video'), function (video) {
      return video.querySelector('source[data-oz-lazy-src]');
    });
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(load);
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          load(entry.target);
        });
      },
      { rootMargin: '200px 0px' }
    );
    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
})();
